export default {
    index: {
        listagem_empresas: 'Listagem de Empresas',
        empresa_nao_encontrada: 'Nenhuma empresa encontrada',
        criar_empresa: 'Criar empresa',
        editar: 'Editar',
        nome: 'Nome',
        apelido: 'Apelido',
        fornecedor: 'Fornecedor'
    },
    form: {
        empresa_principal: 'Empresa Principal',
        importar: 'Importar',
        importar_vs: 'Importar do Veus Saúde',
        importar_empresa_vs: 'Importar empresa do Veus Saúde',
        informacoes: 'Informações',
        nome: 'Nome',
        nome_descricao: 'Nome da Empresa',
        mnemonico: 'Mnemônico',
        mnemonico_descricao: 'Mnemônico da Empresa',
        id_solicitacao: 'ID Solicitação',
        id_solicitacao_descricao: 'ID Solicitação da Empresa ao RNDS',
        cnpj_empresa_descricao: 'CNPJ da Empresa SOMENTE NÚMEROS',
        cnes_empresa_descricao: 'CNES da Empresa',
        veus_id_descricao: 'ID da Empresa no Veus Saúde',
        pesquisar: 'Pesquisar',
        empresa_criada_sucesso: 'Empresa criada com sucesso!',
        empresa_atualizada_sucesso: 'Empresa atualizada com sucesso!',
        provider: 'Fornecedor',
        controle_qualidade: 'Controle de Qualidade',
        usuario: 'Usuário',
        usuario_descricao: 'Usuário da empresa no sistema de controle de qualidade.',
        senha: 'Senha',
        senha_descricao: 'Senha da empresa no sistema de controle de qualidade.'
    }
}